import AccidentsIncidentsTemplate from "../../features/pendingSignOffs/templates/AccidentsIncidentsTemplate";

export default function AccidentsIncidentsScreen() {
  return <AccidentsIncidentsTemplate />;
}
